import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";

import type { IExportDomainsService } from "../types/exportDomainsService";

import { dynamicsDomainService, hubspotDomainService, salesforceDomainService } from "./exportDomainService";

export const getDomainService = (integration: CrmIntegrationProvider): IExportDomainsService => {
    if (integration === "salesforce") {
        return salesforceDomainService;
    }

    if (integration === "dynamics") {
        return dynamicsDomainService;
    }

    return hubspotDomainService;
};